import { ThemeProvider } from "@emotion/react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Recognition from "./pages/Recognition";
import projectTheme from "./assets/theme/Theme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Suspense } from "react";
import Spinner from "./component/Spinner";
import Loader from "./component/Loader";
import VideoCall from "./pages/VideoCall/VideoCall";

function App() {
  return (
    <>
      <ToastContainer
        limit={3}
        autoClose={5000}
        hideProgressBar={false}
      ></ToastContainer>
      <Suspense fallback={<Spinner />}>
        <Loader />
        <ThemeProvider theme={projectTheme}>
          <BrowserRouter>
            <Routes>
              <Route path="/ai-assistant" element={<Recognition />} />
              <Route path="/ai-assistant/videocall" element={<VideoCall />} />
              <Route
                path="*"
                element={<Navigate to="/ai-assistant" replace />}
              />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </Suspense>
    </>
  );
}

export default App;
